
import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import Bet from 'src/shared/charts/bets/bet.jsx'
import VotingForm from './voting_form.jsx'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {
  Legend
} from 'recharts';
import { VelocityTransitionGroup, VelocityComponent } from 'velocity-react';
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';
import useTranslation from "../../../../virtual_congress/effects/use_translation"
import {useVideoRoomEventFor} from "./utils.js";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },

});

export default function Voting({videoRoom, event, options, votingFormOptions, ...props}) {
  const classes = useStyles();

  const allBets = useSelector(state => state.bets)
  const betsFromEvent = useVideoRoomEventFor(videoRoom, videoRoom.take_bets_from, options?.overrideEvent)
  const bets = _.filter(allBets, (bet, betId) => bet.visible && !bet.archived && bet.event_id == betsFromEvent.id)
  const hostname = useSelector(state => state.hostname)

  /* Colors for RenderedHtmlContent */
  const colors = {
    "flavecsr22": ["#87802E","#72C0D4","#D4CA5D","#D44878"]
  }

  if(options?.overrideEvent) {
    console.log("Filtering votings by", options.overrideEvent, allBets)
  }

  const bettings = useSelector(state => state.bettings)
  const betColors = videoRoom?.voting_result_colors?.split(",") || props.betColors || options?.betColors || colors[hostname] ||["#AFAFAF","#6A6A6A","#333333","#234f1E", "#028A0F", "#597D35"]
  const t = useTranslation(null, true)

  const legendRenderer = (value, entry) => {
    return <span dangerouslySetInnerHTML={{__html: value}}></span>;
  };

  console.log("bets", bets)
  return (
    <fieldset>
    <VelocityTransitionGroup component="div" enter={{animation: "slideDown"}} leave={{animation: "slideUp"}} >
      {options?.header && options.header }
      {_.map(bets, (bet, betId) => {
        console.log("bet", betId, bet, bet.answer_stats)
        
        let betting = bettings.find((betting) => betting.bet_id == bet.id)
        let maximum = _.sum(Object.values(bet.answer_stats))
        let answers = _.map(bet.answer_stats, (amount, title) => { return { name: title, value: maximum > 0 ? +((amount / maximum) * 100).toFixed(2) : +(100 / Object.keys(bet.answer_stats).length).toFixed(2) } })

        return (
          <Card key={"bet_container_" + betId} className="mb-2" variant="outlined">
            <CardContent>

              <Typography className={classes.title} color="textSecondary" gutterBottom>
                <div dangerouslySetInnerHTML={{ __html: bet.title.trim()}}/>
              </Typography>

              
              {(bet.show_results && (betting != null || bet.locked)) ? ( 
                  <>
                  <Bet colors={betColors} data={answers} height={options?.votingHeight || 300} bet={bet}
                   >
                    <Legend formatter={legendRenderer}/>
                  </Bet>
                  </>
              ) : (
                bet.locked ? (
                  <span>{videoRoom.voting_locked_bet_text || t("video_room.voting.locked_bet_text") || options?.lockedBetText || "Diese Umfrage wird in Kürze freigegeben."}</span>
                ) : (
                  <VotingForm bet={bet} betting={betting} options={votingFormOptions} thankYouText={props.thankYouText || options?.thankYouText} videoRoom={videoRoom}/>
                )
              )}
              
            </CardContent>
          </Card>
        )
        })
      }
    </VelocityTransitionGroup>

    </fieldset>
  )
}
